// import React, { useEffect, useState, useContext } from 'react';
// import { AuthContext } from '../../context/AuthContext';
// import { useParams, useNavigate } from 'react-router-dom';
// import Navbar from '../Navbar';
// import axios from 'axios';
// // import React, { useEffect, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import Navbar from "../Navbar";
// // import axios from "axios";
// import Env from "../../runtimeEnv";

// const roomBaseUrls = {
//   beach: "https://plutonichealth.co/beach",
//   mountain: "https://plutonichealth.co/forest",
//   park: "https://plutonichealth.co/park",
//   campsite: "https://plutonichealth.co/campsite",
//   "park-therapy": "https://plutonichealth.co/park",
//   "beach-therapy": "https://plutonichealth.co/beach",
//   "forest-therapy": "https://plutonichealth.co/forest",
//   "campsite-therapy": "https://plutonichealth.co/campsite",
//   // "npcgpttherapist888": "https://plutonichealth.co/npcgpttherapist888",
// };

// function UnityRoom() {
//   const navigate = useNavigate();
//   const { roomType } = useParams();
//   const [roomUrl, setRoomUrl] = useState('');
//   const [isValidSession, setIsValidSession] = useState(false);
//   const {
//     currentNickname,
//     setCurrentNickname,
//     handleLogout,
//     setCurrentFormType,
//   } = useContext(AuthContext);

//   useEffect(() => {
//     const savedRoomId = sessionStorage.getItem("meetingID");
//     const savedUserId = sessionStorage.getItem("userId");

//     console.log("[UnityRoom] roomType:", roomType);
//     console.log("[UnityRoom] roomBaseUrls[roomType]:", roomBaseUrls[roomType]);

//     if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
//       setRoomId(savedRoomId);
//       setUserId(savedUserId);
//       setRoomUrl(
//         `${roomBaseUrls[roomType]}?roomId=${savedRoomId}&userId=${savedUserId}`
//       );
//       setIsValidSession(true);
//     } else {
//       console.warn('[UnityRoom] Missing or invalid session data.');
//       setIsValidSession(false);
//       navigate("/therapy-rooms"); // Redirect if the session is invalid
//     }
//   }, [roomType, navigate]);

//   useEffect(() => {
//     const setupUnityCommunication = () => {
//       console.log("setting up unity iframe ");
//       const unityIframe = document.getElementById("unity-iframe");
//       if (!unityIframe) {
//         console.error("[UnityRoom] Unity iframe not found.");
//         return;
//       }

//       // console.log('[UnityRoom] Unity iframe found. Setting up communication...');

//       // *** Ensure handleUnityMessage is defined properly ***
//       const handleUnityMessage = async (event) => {
//         console.log(
//           "[UnityRoom] Message received from Unity:",
//           event.data,
//           "from origin:",
//           event.origin
//         );

//         const trustedOrigins = [
//           "https://plutonichealth.co",
//           "http://localhost:3000",
//         ];
//         if (!trustedOrigins.includes(event.origin)) {
//           console.warn("[UnityRoom] Untrusted origin:", event.origin);
//           return;
//         }

//         if (event.data?.type === "unityReady") {
//           console.log("[UnityRoom] Unity is ready to receive data!");
//           const gatewayUrls = {
//     userGatewayUrl: Env.REACT_APP_USER_URL,
//     meetingsGatewayUrl: Env.REACT_APP_MEETINGS_URL,
//     sessionsGatewayUrl: Env.REACT_APP_SESSIONS_URL,
//   };

//           const message = JSON.stringify({
//             userId,
//             roomId,
//             gatewayUrls,
//           });
//           // const message = JSON.stringify({ userId, roomId });
//           console.log(
//             "[UnityRoom] Sending serialized message to Unity:",
//             message
//           );

//           if (unityIframe.contentWindow) {
//             unityIframe.contentWindow.postMessage(
//               message,
//               "https://plutonichealth.co"
//             );
//           } else {
//             console.error(
//               "[UnityRoom] contentWindow is null. Cannot send message."
//             );
//           }
//         }

//         // *** Handle leaveSession event ***
//         else if (event.data?.type === "leaveSession") {
//           console.log(
//             "[UnityRoom] User is leaving the session. Setting online status to false."
//           );

//           if (userId && roomId) {
//             try {
//               await axios.post(`${process.env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`, {
//                 meetingID: roomId,
//                 online: false,
//               });
//               console.log('[UnityRoom] Online status updated successfully.');
//             } catch (error) {
//               console.error('[UnityRoom] Failed to update online status:', error);
//             }
//           }

//           navigate('/therapy-rooms');
//         }
//       };

//       window.addEventListener('message', handleUnityMessage);
//       return () => window.removeEventListener('message', handleUnityMessage);
//     };

//     if (isValidSession) {
//       const observer = new MutationObserver(() => {
//         if (document.getElementById("unity-iframe")) {
//           setupUnityCommunication();
//           observer.disconnect();
//         }
//       });

//       observer.observe(document.body, { childList: true, subtree: true });
//       return () => observer.disconnect();
//     }
//   }, [isValidSession, navigate]);

//   if (!isValidSession) {
//     return (
//       <div
//         style={{
//           width: "100%",
//           height: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <p>
//           Session data is missing or invalid. Please navigate back to the
//           Therapy Rooms.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100vw',
//       height: '100vh',
//       margin: 0,
//       padding: 0,
//       overflow: 'hidden',
//     }}>
//       <Navbar
//         setCurrentNickname={setCurrentNickname}
//         currentNickname={currentNickname}
//         setCurrentFormType={setCurrentFormType}
//         handleLogout={handleLogout}
//         showButtons={true}
//         PlutonicuserID={sessionStorage.getItem('userId')}
//       />

//       <style>
//         {`
//           @media (min-width: 1400px) {
//             #unity-iframe {
//               position: fixed !important;
//               top: 96px !important;
//               left: 0 !important;
//               width: 100vw !important;
//               height: calc(100vh - 95px) !important;
//               transform: scale(1) !important;
//               transform-origin: center center !important;
//             }
//           }
//         `}
//       </style>

//       {roomUrl ? (
//         <iframe
//           id="unity-iframe"
//           src={roomUrl}
//           style={{
//             position: 'absolute',
//             top: '80px',
//             left: '0',
//             width: '100vw',
//             height: 'calc(100vh - 80px)',
//             border: 'none',
//             display: 'block',
//             overflow: 'hidden',
//           }}
//           title="Unity WebGL Build"
//           allow="fullscreen; camera; microphone; display-capture"
//           onLoad={() => {
//             console.log('[UnityRoom] Iframe loaded. Ready to send message.');
//             const unityIframe = document.getElementById('unity-iframe');
//             if (unityIframe && unityIframe.contentWindow) {
//               const message = JSON.stringify({
//                 userId: sessionStorage.getItem('userId'),
//                 roomId: sessionStorage.getItem('meetingID'),
//               });
//               unityIframe.contentWindow.postMessage(message, 'https://plutonichealth.co');
//             }
//           }}
//         />
//       ) : (
//         <p>Loading Unity Room...</p>
//       )}
//     </div>
//   );
// }

// export default UnityRoom;

import React, { useEffect, useRef, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import UnityLoadingWarning from "../UnityLoadingWarning";
import axios from "axios";
import Env from "../../runtimeEnv";
import { isNativeMobileShell } from "../../native/mobileBridge";
import { isDesktopUnityPreloadEligible } from "../../utils/unityWebglPreloader";
import {
  getUnityRoomLoadingImage,
  getUnityRoomLoadingTitle,
} from "../../utils/unityRoomLoadingImages";

const currentDomain = window.location.hostname;

const isLocalhost =
  currentDomain === "localhost" || currentDomain === "127.0.0.1";
const targetDomain = isLocalhost
  ? "featureenv.plutonichealth.co"
  : currentDomain;

const isProduction = currentDomain === "plutonichealth.co";
const hasSameOriginUnityProxy = currentDomain === "mobiledev.plutonichealth.co";
const developmentUnityOrigin = hasSameOriginUnityProxy
  ? window.location.origin
  : "https://devenv.plutonichealth.co";
const developmentAiUnityOrigin = hasSameOriginUnityProxy
  ? window.location.origin
  : "https://featureenv.plutonichealth.co";

const roomBaseUrls = isProduction
  ? {
      beach: `https://plutonichealth.co/beach`,
      mountain: `https://plutonichealth.co/forest`,
      park: `https://plutonichealth.co/park`,
      campsite: `https://plutonichealth.co/campsite`,
      winterHoliday: `https://plutonichealth.co/winter-holiday`,
      "park-therapy": `https://plutonichealth.co/park`,
      "beach-therapy": `https://plutonichealth.co/beach`,
      "forest-therapy": `https://plutonichealth.co/forest`,
      "campsite-therapy": `https://plutonichealth.co/campsite`,
      "winter-holiday": `https://plutonichealth.co/winter-holiday`,
      "demo": `https://plutonichealth.co/demo`,
    }
  : {
      beach: `${developmentUnityOrigin}/devenv-plutonictherapy/beach-dev/index.html`,
      mountain: `${developmentUnityOrigin}/devenv-plutonictherapy/forest-dev/index.html`,
      park: `${developmentUnityOrigin}/devenv-plutonictherapy/park-dev/index.html`,
      campsite: `${developmentUnityOrigin}/devenv-plutonictherapy/campsite-dev/index.html`,
      winterHoliday: `${developmentUnityOrigin}/devenv-plutonictherapy/winter-holiday-dev/index.html`,
      "park-therapy": `${developmentUnityOrigin}/devenv-plutonictherapy/park-dev/index.html`,
      "beach-therapy": `${developmentUnityOrigin}/devenv-plutonictherapy/beach-dev/index.html`,
      "forest-therapy": `${developmentUnityOrigin}/devenv-plutonictherapy/forest-dev/index.html`,
      "campsite-therapy": `${developmentUnityOrigin}/devenv-plutonictherapy/campsite-dev/index.html`,
      "winter-holiday": `${developmentUnityOrigin}/devenv-plutonictherapy/winter-holiday-dev/index.html`,
      "beach-ai-companion":
        `${developmentAiUnityOrigin}/devenv-ai-plutonictherapy/beach-ai-dev/index.html`,
      "beach-ai-dev":
        `${developmentAiUnityOrigin}/devenv-ai-plutonictherapy/beach-ai-dev/index.html`,
    };

function UnityRoom() {
  const navigate = useNavigate();
  const location = useLocation();
  const { roomType } = useParams();
  const [roomUrl, setRoomUrl] = useState("");
  const [isValidSession, setIsValidSession] = useState(false);
  const [showLoadingPlaceholder, setShowLoadingPlaceholder] = useState(true);
  const [unityLoadingProgress, setUnityLoadingProgress] = useState(null);
  const progressMonitorRef = useRef(null);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    setCurrentFormType,
  } = useContext(AuthContext);

  useEffect(() => {
    setShowLoadingPlaceholder(true);
    setUnityLoadingProgress(null);
    const savedRoomId = sessionStorage.getItem("meetingID");
    const savedUserId = sessionStorage.getItem("userId");









    if (savedRoomId && savedUserId && roomType && roomBaseUrls[roomType]) {
      if (!isNativeMobileShell()) {
        axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/meeting-join-context/${savedUserId}`, {
          meetingID: savedRoomId,
          joinDevice: "webgl",
        }, { withCredentials: true }).catch(() => {});
      }
      const BUILD_VERSION = "5252026";

      const finalUrl =
      `${roomBaseUrls[roomType]}?v=${BUILD_VERSION}&roomId=${savedRoomId}&userId=${savedUserId}`;

      setRoomUrl(finalUrl);
      setIsValidSession(true);
    } else {
      console.warn("[UnityRoom] Missing or invalid session data.");
      setIsValidSession(false);
      navigate("/therapy-rooms");
    }
  }, [roomType, navigate, location.key]);

  useEffect(() => () => clearInterval(progressMonitorRef.current), []);

  const monitorUnityProgress = (unityIframe) => {
    clearInterval(progressMonitorRef.current);
    progressMonitorRef.current = setInterval(() => {
      try {
        const frameDocument = unityIframe.contentDocument;
        const progressFill = frameDocument?.querySelector(
          ".progress-bar-fill, #unity-progress-bar-full"
        );
        if (!progressFill) return;

        const inlineWidth = progressFill.style.width;
        let progress = inlineWidth.endsWith("%")
          ? Number.parseFloat(inlineWidth)
          : Number.NaN;
        if (!Number.isFinite(progress)) {
          const trackWidth = progressFill.parentElement?.getBoundingClientRect().width || 0;
          const fillWidth = progressFill.getBoundingClientRect().width;
          if (trackWidth > 0) progress = (fillWidth / trackWidth) * 100;
        }
        if (Number.isFinite(progress)) {
          setUnityLoadingProgress(Math.max(0, Math.min(100, progress)));
        }
      } catch {
        // Cross-origin development builds cannot expose their DOM. The
        // splash remains visible until Unity sends its completion message.
        clearInterval(progressMonitorRef.current);
      }
    }, 100);
  };

  // useEffect(() => {
  //   const setupUnityCommunication = () => {
  //     const unityIframe = document.getElementById("unity-iframe");
  //     if (!unityIframe) return;

  //     const handleUnityMessage = async (event) => {
  //       console.log(
  //         "[UnityRoom] Message received from Unity:",
  //         event.data,
  //         "origin:",
  //         event.origin
  //       );

  //       const trustedOrigins = [
  //         "https://plutonichealth.co",
  //         "http://localhost:3000",
  //         "https://devenv-plutonictherapy.s3.us-east-1.amazonaws.com",
  //       ];
  //       if (!trustedOrigins.includes(event.origin)) {
  //         console.warn("[UnityRoom] Untrusted origin:", event.origin);
  //         return;
  //       }

  //       if (event.data?.type === "unityReady") {
  //         console.log("[UnityRoom] Unity is ready to receive data!");
  //         const gatewayUrls = {
  //           userGatewayUrl: Env.REACT_APP_USER_URL,
  //           meetingsGatewayUrl: Env.REACT_APP_MEETINGS_URL,
  //           sessionsGatewayUrl: Env.REACT_APP_SESSIONS_URL,
  //         };

  //         const message = JSON.stringify({
  //           userId: sessionStorage.getItem("userId"),
  //           roomId: sessionStorage.getItem("meetingID"),
  //           gatewayUrls,
  //         });
  //         // const message = JSON.stringify({ userId, roomId });
  //         console.log(
  //           "[UnityRoom] Sending serialized message to Unity:",
  //           message
  //         );

  //         if (unityIframe.contentWindow) {
  //           setTimeout(() => {
  //             console.log(
  //               "[UnityRoom] Sending delayed message to Unity:",
  //               message
  //             );
  //             unityIframe.contentWindow.postMessage(
  //               message,
  //               "https://plutonichealth.co"
  //             );
  //           }, 300);
  //         } else {
  //           console.error(
  //             "[UnityRoom] contentWindow is null. Cannot send message."
  //           );
  //         }
  //       } else if (event.data?.type === "leaveSession") {
  //         console.log("[UnityRoom] User leaving session. Updating status...");
  //         const userId = sessionStorage.getItem("userId");
  //         const roomId = sessionStorage.getItem("meetingID");

  //         if (userId && roomId) {
  //           try {
  //             await axios.post(
  //               `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
  //               {
  //                 meetingID: roomId,
  //                 online: false,
  //               }
  //             );
  //             console.log("[UnityRoom] Online status updated successfully.");
  //           } catch (error) {
  //             console.error(
  //               "[UnityRoom] Failed to update online status:",
  //               error
  //             );
  //           }
  //         }

  //         navigate("/therapy-rooms");
  //       }
  //     };

  //     window.addEventListener("message", handleUnityMessage);
  //     return () => window.removeEventListener("message", handleUnityMessage);
  //   };

  //   if (isValidSession) {
  //     const observer = new MutationObserver(() => {
  //       if (document.getElementById("unity-iframe")) {
  //         setupUnityCommunication();
  //         observer.disconnect();
  //       }
  //     });

  //     observer.observe(document.body, { childList: true, subtree: true });
  //     return () => observer.disconnect();
  //   }
  // }, [isValidSession, navigate]);

  useEffect(() => {
    if (!isValidSession || !roomUrl) return undefined;

    const allowedOrigin = new URL(roomUrl).origin;
    let sessionTimer;
    let revealTimer;

    const scheduleReveal = () => {
      clearTimeout(revealTimer);
      revealTimer = setTimeout(() => {
        clearInterval(progressMonitorRef.current);
        setShowLoadingPlaceholder(false);
      }, 900);
    };

    const sendSessionData = () => {
      const unityIframe = document.getElementById("unity-iframe");
      if (!unityIframe?.contentWindow) {
        console.error("[UnityRoom] contentWindow is null. Cannot send message.");
        return;
      }

      const message = JSON.stringify({
        userId: sessionStorage.getItem("userId"),
        roomId: sessionStorage.getItem("meetingID"),
        apiGatewayUrl: Env.REACT_APP_API_GATEWAY_URL,
      });

      unityIframe.contentWindow.postMessage(message, allowedOrigin);
    };

    const handleUnityMessage = async (event) => {


        const trustedOrigins = [allowedOrigin, window.location.origin];

        if (!trustedOrigins.includes(event.origin)) {
          console.warn("[UnityRoom] Untrusted origin:");
          return;
        }

        if (event.data?.type === "unityLoaded") {
          setUnityLoadingProgress(100);
          scheduleReveal();
        } else if (event.data?.type === "unityReady") {
          setUnityLoadingProgress(100);
          clearTimeout(sessionTimer);
          sessionTimer = setTimeout(sendSessionData, 300);
          scheduleReveal();
        } else if (event.data?.type === "unityActivity") {
          window.dispatchEvent(new Event("plutonic-unity-activity"));
        } else if (event.data?.type === "leaveSession") {

          const userId = sessionStorage.getItem("userId");
          const roomId = sessionStorage.getItem("meetingID");

          if (userId && roomId) {
            try {
              await axios.post(
                `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${userId}`,
                {
                  meetingID: roomId,
                  online: false,
                }
              );

            } catch (error) {
              console.error("[UnityRoom] Failed to update online status:");
            }
          }

          navigate("/therapy-rooms");
        }
    };

    window.addEventListener("message", handleUnityMessage);
    return () => {
      clearTimeout(sessionTimer);
      clearTimeout(revealTimer);
      window.removeEventListener("message", handleUnityMessage);
    };
  }, [isValidSession, navigate, roomUrl]);

  const loadingImage = isDesktopUnityPreloadEligible()
    ? getUnityRoomLoadingImage(roomType)
    : null;
  const loadingTitle = getUnityRoomLoadingTitle(roomType);

  if (!isValidSession) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>
          Session data is missing or invalid. Please go back to Therapy Rooms.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
      }}
    >
      <Navbar
        setCurrentNickname={setCurrentNickname}
        currentNickname={currentNickname}
        setCurrentFormType={setCurrentFormType}
        handleLogout={handleLogout}
        showButtons={true}
        PlutonicuserID={sessionStorage.getItem("userId")}
      />

      <style>
        {`
          #unity-iframe {
            top: 78px;
            height: calc(100vh - 78px);
          }
          #unity-loading-placeholder {
            top: 78px;
            height: calc(100vh - 78px);
          }
          @media (min-width: 640px) {
            #unity-iframe {
              top: 83px;
              height: calc(100vh - 83px);
            }
            #unity-loading-placeholder {
              top: 83px;
              height: calc(100vh - 83px);
            }
          }
        `}
      </style>

      {roomUrl ? (
        <>
        <UnityLoadingWarning isLoading={showLoadingPlaceholder} />
        <iframe
          id="unity-iframe"
          src={roomUrl}
          style={{
            position: "absolute",
            left: "0",
            width: "100vw",
            border: "none",
            display: "block",
            overflow: "hidden",
          }}
          title="Unity WebGL Build"
          allow="fullscreen; camera; microphone; display-capture"
          onLoad={() => {

            const unityIframe = document.getElementById("unity-iframe");
            if (unityIframe && unityIframe.contentWindow) {
              const allowedOrigin = new URL(roomUrl).origin;
              const message = JSON.stringify({
                userId: sessionStorage.getItem("userId"),
                roomId: sessionStorage.getItem("meetingID"),
                apiGatewayUrl: Env.REACT_APP_API_GATEWAY_URL,
              });

              unityIframe.contentWindow.postMessage(message, allowedOrigin);
              monitorUnityProgress(unityIframe);

              // Production WebGL rooms are served from this same origin, so
              // input can be forwarded directly without rebuilding Unity.
              // Cross-origin builds can send { type: "unityActivity" } via
              // postMessage, which is handled above.
              try {
                if (allowedOrigin === window.location.origin) {
                  if (unityIframe.__plutonicActivityCleanup) {
                    unityIframe.__plutonicActivityCleanup();
                  }
                  const forwardActivity = () =>
                    window.dispatchEvent(new Event("plutonic-unity-activity"));
                  const activityEvents = [
                    "pointerdown",
                    "pointermove",
                    "keydown",
                    "touchstart",
                    "scroll",
                  ];
                  const options = { passive: true };
                  activityEvents.forEach((eventName) =>
                    unityIframe.contentWindow.addEventListener(
                      eventName,
                      forwardActivity,
                      options
                    )
                  );
                  unityIframe.__plutonicActivityCleanup = () =>
                    activityEvents.forEach((eventName) =>
                      unityIframe.contentWindow.removeEventListener(
                        eventName,
                        forwardActivity,
                        options
                      )
                    );
                }
              } catch (_) {
                // Cross-origin WebGL builds use the postMessage path instead.
              }
            }
          }}
        />
        {loadingImage && (
          <div
            id="unity-loading-placeholder"
            aria-live="polite"
            aria-label="Loading your space"
            style={{
              position: "absolute",
              left: 0,
              width: "100vw",
              zIndex: 10,
              overflow: "hidden",
              backgroundColor: "#000",
              opacity: showLoadingPlaceholder ? 1 : 0,
              pointerEvents: showLoadingPlaceholder ? "auto" : "none",
              transition: "opacity 400ms ease",
            }}
          >
            <img
              src={loadingImage}
              alt=""
              aria-hidden="true"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "min(640px, 90vw)",
                  color: "white",
                  fontFamily: "Arial, sans-serif",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "50px", lineHeight: "80px" }}>
                  {loadingTitle}
                </div>
                <div style={{ fontSize: "30px", lineHeight: "70px" }}>
                  Loading Session...
                </div>
                {unityLoadingProgress !== null && (
                  <div
                    aria-label={`Unity loading ${Math.round(unityLoadingProgress)}%`}
                    style={{
                      width: "100%",
                      padding: "3px",
                      borderRadius: "3px",
                      background: "#e0e0e0",
                      boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    <div
                      style={{
                        width: `${unityLoadingProgress}%`,
                        height: "18px",
                        borderRadius: "3px",
                        background: "#c1e6ff",
                        transition: "width 500ms ease-in-out",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        </>
      ) : (
        <p>Loading Unity Room...</p>
      )}
    </div>
  );
}

export default UnityRoom;
